"use strict";Object.defineProperty(exports, "__esModule", {value: true});



var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/visually-hidden/visually-hidden.tsx
var TagName = "span";
var useVisuallyHidden = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useVisuallyHidden2(props) {
    props = {
      ...props,
      style: {
        border: 0,
        clip: "rect(0 0 0 0)",
        height: "1px",
        margin: "-1px",
        overflow: "hidden",
        padding: 0,
        position: "absolute",
        whiteSpace: "nowrap",
        width: "1px",
        ...props.style
      }
    };
    return props;
  }
);
var VisuallyHidden = _PTOCUU2Dcjs.forwardRef.call(void 0, function VisuallyHidden2(props) {
  const htmlProps = useVisuallyHidden(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useVisuallyHidden = useVisuallyHidden; exports.VisuallyHidden = VisuallyHidden;
